import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class SkinCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false
    };

    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}content/skin/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              this.setState(
                () => ({
                  skin: resp.data.data
                }),
                () => {
                  this.setState(() => ({
                    edit: true,
                    loading: false
                  }));
                },
                error => {
                  this.error(error.response.statusText);
                }
              );
            });
        }
      );
    }
  }

  enviar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      path: this.state.path
    };
    if (this.state.path === undefined) {
      toastr.error(
        "Fail",
        "Favor fazer o envio do arquivo no início da página."
      );
    } else {
      axios
        .post(`${URL.api}content/skin/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            this.props.history.push("/skin/list");
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    }
  }

  atualizar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      path: this.state.path
    };
    axios
      .post(`${URL.api}content/skin/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/skin/list");
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  done(uploads) {
    this.setState(() => ({
      path: uploads[0]
    }));
  }

  render() {
    const Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/skin/list", to: "/skin/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <div>
            <Uploader
              type="skin"
              maxFiles={1}
              acceptedFileTypes={["application/x-zip-compressed"]}
              allowMultiple
              labelIdle='Arraste e solte seu arquivo ou <span class="filepond--label-action">procure</span>'
              done={uploads => this.done(uploads)}
            />
            <Form
              avatar
              fields={Fields}
              buttons={buttons}
              onSubmit={this.state.edit ? this.atualizar : this.enviar}
              initialValues={this.state.skin}
              edit={this.state.edit}
            />
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SkinCreate);
